<div class="step-two">
    <form id="checkoutform" method="post"></form>

    <div class="step-header">
        <div class="icon-wrapper">
            <i data-feather="credit-card"></i>
        </div>
        <h2>Método de Pago</h2>
    </div>

    <div class="payment-options">
        <!-- Credit/Debit Card -->
        <div class="payment-card" [class.active]="isCreditCard" (click)="isCreditCard = true; onChangePaymentCreditCard()">
            <div class="card-header">
                <div class="header-left">
                    <div class="icon-wrapper">
                        <i data-feather="credit-card"></i>
                    </div>
                    <div class="title-group">
                        <h3>Tarjeta de Crédito / Débito</h3>
                        <span class="badge info">Pago online seguro</span>
                    </div>
                </div>
                <div class="radio-indicator">
                    <div class="radio-dot"></div>
                </div>
            </div>

            <div class="card-content" *ngIf="isCreditCard">
                <div class="payment-form">
                    <h4 class="section-title">Seleccionar cuotas</h4>
                    <div class="form-row">
                        <mat-form-field appearance="outline" class="form-field">
                            <mat-label>Número de cuotas</mat-label>
                            <mat-select name="installment" [(ngModel)]="cardInstallment" (selectionChange)="applyInstallments()">
                                <mat-option *ngFor="let item of getInstallmentsByCreditCard()" [value]="item">{{ item.title }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>

        <!-- MutualCard -->
        <div class="payment-card" [class.active]="isMutualCard" (click)="isMutualCard = true; onChangePaymentMutual()">
            <div class="card-header">
                <div class="header-left">
                    <div class="icon-wrapper">
                        <i data-feather="credit-card"></i>
                    </div>
                    <div class="title-group">
                        <h3>Tarjeta de Crédito MutualCard</h3>
                        <span class="badge success">Financiación especial</span>
                    </div>
                </div>
                <div class="radio-indicator">
                    <div class="radio-dot"></div>
                </div>
            </div>

            <div class="card-content" *ngIf="isMutualCard">
                <div class="payment-form">
                    <h4 class="section-title">Seleccionar cuotas</h4>
                    <div class="form-row">
                        <mat-form-field appearance="outline" class="form-field">
                            <mat-label>Número de cuotas</mat-label>
                            <mat-select name="installment" [(ngModel)]="cardInstallment" (selectionChange)="applyInstallments()">
                                <mat-option *ngFor="let item of getInstallmentsByMutualCard()" [value]="item">{{ item.title }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <h4 class="section-title">Datos de la Tarjeta</h4>
                    <div class="form-row">
                        <mat-form-field appearance="outline" class="form-field">
                            <mat-label>Nombre y apellido</mat-label>
                            <input matInput placeholder="Nombre completo" name="name_card_mut" [(ngModel)]="cardName" (input)="onCardNameInput($event)" />
                            <mat-hint>Escribirlo exactamente igual como figura en la tarjeta</mat-hint>
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field appearance="outline" class="form-field">
                            <mat-label>Número de Tarjeta</mat-label>
                            <input matInput maxlength="19" name="number_card_mut" [value]="cardNumberDisplay" (input)="onCardNumberInput($event)" placeholder="1234 5678 9012 3456">
                            <span matSuffix class="card visa"></span>
                        </mat-form-field>
                    </div>

                    <div class="form-row expiration-row">
                        <mat-form-field appearance="outline" class="form-field">
                            <mat-label>Mes</mat-label>
                            <mat-select name="expiration_card_mut" [(ngModel)]="cardMonth">
                                <mat-option [value]="'01'">01</mat-option>
                                <mat-option [value]="'02'">02</mat-option>
                                <mat-option [value]="'03'">03</mat-option>
                                <mat-option [value]="'04'">04</mat-option>
                                <mat-option [value]="'05'">05</mat-option>
                                <mat-option [value]="'06'">06</mat-option>
                                <mat-option [value]="'07'">07</mat-option>
                                <mat-option [value]="'08'">08</mat-option>
                                <mat-option [value]="'09'">09</mat-option>
                                <mat-option [value]="'10'">10</mat-option>
                                <mat-option [value]="'11'">11</mat-option>
                                <mat-option [value]="'12'">12</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="form-field">
                            <mat-label>Año</mat-label>
                            <mat-select name="expiration_y_card_mut" [(ngModel)]="cardYear">
                                <mat-option [value]="'25'">25</mat-option>
                                <mat-option [value]="'26'">26</mat-option>
                                <mat-option [value]="'27'">27</mat-option>
                                <mat-option [value]="'28'">28</mat-option>
                                <mat-option [value]="'29'">29</mat-option>
                                <mat-option [value]="'30'">30</mat-option>
                                <mat-option [value]="'31'">31</mat-option>
                                <mat-option [value]="'32'">32</mat-option>
                                <mat-option [value]="'33'">33</mat-option>
                                <mat-option [value]="'34'">34</mat-option>
                                <mat-option [value]="'35'">35</mat-option>
                                <mat-option [value]="'36'">36</mat-option>
                                <mat-option [value]="'37'">37</mat-option>
                                <mat-option [value]="'38'">38</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="form-field">
                            <mat-label>CVV</mat-label>
                            <input #cvv matInput maxlength="3" name="code_card_mut" [(ngModel)]="cardCode" (input)="onCvvInput($event)" placeholder="123" />
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>

        <!-- Cash/Transfer/QR -->
        <div class="payment-card" [class.active]="isCash" (click)="isCash = true; onChangePaymentCash()">
            <div class="card-header">
                <div class="header-left">
                    <div class="icon-wrapper">
                        <i data-feather="dollar-sign"></i>
                    </div>
                    <div class="title-group">
                        <h3>Transferencia / Efectivo</h3>
                        <span class="badge warning">Múltiples opciones</span>
                    </div>
                </div>
                <div class="radio-indicator">
                    <div class="radio-dot"></div>
                </div>
            </div>

            <div class="card-content" *ngIf="isCash">
                <div class="payment-info">
                    <div class="info-section">
                        <div class="section-header">
                            <div class="section-icon">
                                <i data-feather="briefcase"></i>
                            </div>
                            <h4>Transferencia Bancaria</h4>
                        </div>
                        <div class="info-card">
                            <p class="bank-name">Asociación Mutual de Venado Tuerto</p>
                            <p class="bank-detail">Banco Hipotecario S.A.</p>
                            <div class="cbu-container">
                                <span class="cbu-label">CBU</span>
                                <span class="cbu-number">0440051630000004901805</span>
                            </div>
                        </div>
                        <div class="info-message">
                            <i data-feather="mail"></i>
                            <span>Luego de realizado el pago envianos el comprobante a <a href="mailto:plazahogar@amvt.com.ar">plazahogar@amvt.com.ar</a></span>
                        </div>
                    </div>

                    <div class="info-section">
                        <div class="section-header">
                            <div class="section-icon">
                                <i data-feather="users"></i>
                            </div>
                            <h4>Efectivo</h4>
                        </div>
                        <div class="info-message">
                            <i data-feather="info"></i>
                            <span>Al terminar la compra, un asesor de Ventas se comunicará con vos para coordinar el pago y finalizar el proceso.</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- MercadoPago QR -->
        <div class="payment-card" [class.active]="isMercadoPagoQR" (click)="isMercadoPagoQR = true; onChangePaymentMercadoPagoQR()">
            <div class="card-header">
                <div class="header-left">
                    <div class="icon-wrapper">
                        <i data-feather="smartphone"></i>
                    </div>
                    <div class="title-group">
                        <h3>MercadoPago QR</h3>
                        <span class="badge success">Pago instantáneo</span>
                    </div>
                </div>
                <div class="radio-indicator">
                    <div class="radio-dot"></div>
                </div>
            </div>

            <div class="card-content" *ngIf="isMercadoPagoQR">
                <div class="payment-info">
                    <div class="info-section">
                        <div class="section-header">
                            <div class="section-icon">
                                <i data-feather="zap"></i>
                            </div>
                            <h4>Pagar con MercadoPago</h4>
                        </div>

                        <!-- Loading State -->
                        <div class="qr-loading" *ngIf="loadingQR">
                            <div class="spinner"></div>
                            <p>Generando código QR...</p>
                        </div>

                        <!-- Error State -->
                        <div class="qr-error" *ngIf="qrError && !loadingQR">
                            <div class="error-icon">
                                <i data-feather="alert-circle"></i>
                            </div>
                            <p>No se pudo generar el código QR</p>
                            <button mat-raised-button color="primary" (click)="retryGenerateQR()">
                                <i data-feather="refresh-cw"></i>
                                Reintentar
                            </button>
                        </div>

                        <!-- QR Display -->
                        <div class="mercadopago-qr-display" *ngIf="mercadoPagoQRData && !loadingQR && !qrError">
                            <div class="qr-container-mp">
                                <img [src]="mercadoPagoQRData.qr_code_url" alt="Código QR MercadoPago" />
                            </div>
                            
                            <div class="qr-info">
                                <div class="total-amount">
                                    <span class="label">Total a pagar:</span>
                                    <span class="amount">${{ mercadoPagoQRData.total | number:'1.2-2' }}</span>
                                </div>
                                
                                <div class="qr-instructions">
                                    <h5>
                                        <i data-feather="info"></i>
                                        Instrucciones:
                                    </h5>
                                    <ol>
                                        <li>Abrí la app de MercadoPago en tu celular</li>
                                        <li>Tocá en "Pagar con QR"</li>
                                        <li>Escaneá este código</li>
                                        <li>Confirmá el pago</li>
                                    </ol>
                                </div>

                                <div class="qr-alternative">
                                    <p>¿Preferís pagar desde el navegador?</p>
                                    <a [href]="mercadoPagoQRData.init_point" target="_blank" mat-raised-button color="accent">
                                        <i data-feather="external-link"></i>
                                        Ir a MercadoPago
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div class="info-message">
                            <i data-feather="check-circle" *ngIf="!isPolling"></i>
                            <div class="spinner-small" *ngIf="isPolling"></div>
                            <span *ngIf="!isPolling">Tu pedido se procesará automáticamente cuando se confirme el pago</span>
                            <span *ngIf="isPolling" class="polling-status">
                                Esperando confirmación del pago...
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="action-buttons">
        <button mat-stroked-button class="btn-back" (click)="onClickBack()">
            <i data-feather="arrow-left"></i>
            Volver
        </button>
        <button 
            mat-raised-button 
            color="primary" 
            class="btn-continue" 
            (click)="onClickSubmit()"
            [disabled]="!isPaymentMethodSelected()"
            [matTooltip]="!isPaymentMethodSelected() ? 'Debe seleccionar un método de pago' : ''">
            <i data-feather="lock"></i>
            Pagar
        </button>
    </div>
</div>
